/**
 * Детект среды клиентского модуля.
 *
 * `window.__nativeBridge` инжектится нативным приложением (через
 * `injectedJavaScriptBeforeContentLoaded`) ДО загрузки страницы. В обычном
 * браузере (заход по QR/ссылке) его нет → мост не активируем.
 *
 * `isInWebView()` — единственный гейт всего webview-кода. Внутри нативного
 * приложения мост активен всегда: деградации в браузерный режим нет — если
 * натива не выйдет на связь, приложение не должно подменяться веб-версией.
 */

/** Проверяет, находится ли страница внутри iframe. */
export const isInsideIframe = (): boolean =>
  typeof window !== 'undefined' && window.self !== window.top;

/** Активен ли webview-режим: присутствует нативный мост. */
export const isInWebView = (): boolean =>
  (typeof window !== 'undefined' && '__nativeBridge' in window) ||
  isInsideIframe();
